export default __webpack_public_path__ + "static/media/Pleft.78969799.jpeg";